import React from 'react';
import { PillarPage } from '../components/PillarPage';
import { mentePage } from '../data/pages/mente';
export function Mente() {
  return <PillarPage content={mentePage} data-id="element-262" data-mp="13kc111f8aqqh" />;
}